import { useMemo, useState } from "react";

import { useARC } from "providers/ARC/ARCProvider";

import { ConnectionState } from "lib/consts/ARC/connection";

import { ReactComponent as AvoidanceBlockedIcon } from "assets/svgs/ARC/AvoidanceBlocked.svg";
import { ReactComponent as AvoidanceDefaultIcon } from "assets/svgs/ARC/AvoidanceDefault.svg";
import { ReactComponent as ARCControlConnectionIcon } from "assets/svgs/network/Coverage3.svg";
import { ReactComponent as SettingIcon } from "assets/svgs/navbar/Setting.svg";

import { useFleet } from "providers/FleetProvider";

const StatusBar = ({
    className = "",
    serialNumber,
    connectionState = ConnectionState.Disconnected,
    onClick = () => {},
}) => {
    const isConnectedToARC = connectionState === ConnectionState.Connected;

    return (
        <div
            className={`flex h-9 w-full  items-center justify-between bg-black90 px-2 ${className}`}
            onClick={onClick}
        >
            <p
                className={`min-w-0 flex-1 truncate text-h5 ${connectionState}`}
                title={serialNumber ?? undefined}
            >
                {serialNumber}
            </p>
            <div className="flex shrink-0 items-center justify-center space-x-2">
                {true ? (
                    <AvoidanceBlockedIcon className={`${!isConnectedToARC && "text-black70"}`} />
                ) : (
                    <AvoidanceDefaultIcon />
                )}
                <ARCControlConnectionIcon
                    className={`${
                        connectionState === ConnectionState.Connecting &&
                        "animate-pulse text-primary2"
                    } ${connectionState === ConnectionState.Disconnected && "text-black70"}`}
                />
                <SettingIcon className={`${!isConnectedToARC && "text-black70"}`} />
            </div>
        </div>
    );
};

const StatusBarMenu = () => {
    const { selectARC, connectionState, selectedARC } = useARC();

    const [showMore, setShowMore] = useState(false);

    // Only use FleetProvider in fleet mode (optional chaining for ARC mode)
    const fleetData = useFleet?.();
    const arcsInfo = useMemo(() => fleetData?.arcsInfo || [], [fleetData?.arcsInfo]);

    const notSelectedARC = ({ serialNumber = null } = {}) =>
        serialNumber !== selectedARC?.serialNumber;

    // Only show dropdown in fleet mode (when FleetProvider exists)
    const hasFleetMode = !!fleetData;

    return (
        <div
            className="relative flex h-9 w-36 min-w-0 shrink cursor-pointer items-center justify-between rounded-r5 sm:w-48 md:w-56 lg:w-64"
            onClick={() => setShowMore(!showMore)}
        >
            <StatusBar
                className="rounded-r5"
                serialNumber={selectedARC?.serialNumber}
                connectionState={connectionState}
            />
            {/* Only show dropdown in fleet mode */}
            {hasFleetMode && (
                <div
                    className={`absolute left-0 top-9 z-50 w-full ${
                        showMore ? "block" : "hidden"
                    } max-h-[300px] overflow-y-scroll`}
                >
                    {arcsInfo.filter(notSelectedARC).map(({ serialNumber }) => {
                        return (
                            <StatusBar
                                key={serialNumber}
                                className="first:rounded-t-r5 last:rounded-b-r5"
                                serialNumber={serialNumber}
                                connectionState={ConnectionState.Disconnected}
                                onClick={() => {
                                    selectARC(serialNumber);
                                }}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default StatusBarMenu;
